import { useState } from "react";
import type { FAQItem } from "@/entities/faq";

interface FAQAccordionProps {
  items: FAQItem[];
}

/**
 * FAQAccordion - FAQ 아코디언 컴포넌트
 */
export const FAQAccordion = ({ items }: FAQAccordionProps) => {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(0);

  return (
    <div className="w-full space-y-4">
      {items.map((item, index) => (
        <div
          key={index}
          className="border border-gray-200 rounded-lg overflow-hidden"
        >
          <button
            onClick={() =>
              setExpandedIndex(expandedIndex === index ? null : index)
            }
            className="w-full flex items-center justify-between p-6 hover:bg-gray-50 transition-colors"
          >
            <div className="flex items-center gap-4 text-left flex-1">
              <div className="w-10 h-10 rounded-full bg-orange-500 text-white flex items-center justify-center flex-shrink-0 text-lg font-semibold">
                {index + 1}
              </div>
              <h3 className="text-lg font-normal text-black">{item.title}</h3>
            </div>
            <div
              className={`w-6 h-6 flex-shrink-0 transition-transform ${
                expandedIndex === index ? "rotate-180" : ""
              }`}
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 9L12 15L18 9"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </button>
          {expandedIndex === index && (
            <div className="px-6 py-6 bg-gray-50 border-t border-gray-200 text-black text-base leading-relaxed whitespace-pre-line">
              {item.content}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
